import { Row, Col, Container, Card, Button, Form, Spinner, FormGroup, Dropdown , Table} from "react-bootstrap";
import Layout from "../../components/Layout";
import { useEffect, useRef, useState } from "react";
import DrewsModal from "../../components/modal/DrewsModal";
import AlertModal from "../../components/modal/AlertModal";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { addUser, deleteMember, getMembers, manageMember } from "../../redux/slices/users";
import Swal from "sweetalert2";

const Managers = () => {

    const dispatch = useDispatch()

    const isLoaded = useRef(false)

    const [showForm, setShowForm] = useState(false)
    const [payload, setPayload] = useState({})
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] =  useState({})
    const [members, setMembers] =  useState([])

    useEffect(() => {
        if(!isLoaded.current) {
            loadMembers()
            isLoaded.current = true
        }
    },[])
    

    const handleInput = (event) => {
        const { name, value } = event.target;

        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setErrors((prevState) => ({ ...prevState, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required` }))
        }
        // else if(name === 'email' && !pattern.test(value)) {
        //     setErrors((prevState) => ({ ...prevState, [name]: 'Please enter a valid email address'}))
        // }
        else {
            setPayload((prevState) => ({...prevState, [name]: value}))
            event.target.style = "border-style: transparent"
            delete errors[name]
            setErrors(errors)
        }
    }

    const loadMembers = () => {
        dispatch(getMembers())
        .then((response) => {
            if(response.payload.success === true) {
                setMembers(response.payload.data)
            }
        })
    }

    const createUser = () => {
        if(!payload.first_name && !payload.last_name && !payload.email && !payload.phone) { return }
        setLoading(true)
        dispatch(addUser(payload))
        .then((response) => {
            if(response.payload?.success === true){
                Swal.fire({
                    icon: "success",
                    text: response.payload?.message
                })
                setShowForm(false)
                setPayload({})
                loadMembers()
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setLoading(false))
    }

    const confirmStatusChange = (id, status) => {
        setLoading(true)
        dispatch(manageMember({user_id: id, activate: status}))
        .then((response) => {
            if(response.payload?.success === true){
                Swal.fire({
                    icon: "success",
                    text: response.payload?.message
                })
                setShowForm(false)
                loadMembers()
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setLoading(false))
    }
    

    const confirmDelete = (id) => {
        setLoading(true)
        dispatch(deleteMember(id))
        .then((response) => {
            if(response.payload?.success === true){
                Swal.fire({
                    icon: "success",
                    text: response.payload?.message
                })
                setShowForm(false)
                loadMembers()
            } else {
                Swal.fire({
                    icon: "error",
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setLoading(false))
    }

   const promptDelete = (member) => {
        Swal.fire({ 
            icon: 'warning', 
            text: `Are you sure you want to delete ${member.name}?`,
            confirmButtonText: 'Yes, Proceed',
            showCancelButton: true,
            cancelButtonText: 'Cancel'
        })
        .then((response) => {
            if(response.isConfirmed) {
                confirmDelete(member.id)
            }
        });
    }

   const manageStatus = (member) => {
        let status = member.active ? 'desctivate' : 'activate';
        Swal.fire({ 
            icon: 'warning', 
            text: `Are you sure you want to ${status} ${member.name}?`,
            confirmButtonText: 'Yes, Proceed',
            showCancelButton: true,
            cancelButtonText: 'Cancel'
        })
        .then((response) => {
            if(response.isConfirmed) {
                confirmStatusChange(member.id, !member.active)
            }
        });
    }

    return (
        <Layout>
            <Container className="mt-5 px-4 mb-4">
                <Col md={11} lg={11} sm={12} className="d-flex align-items-center justify-content-between mb-5 mx-auto">
                    <h3>Managers</h3>
                    <Button 
                        type="button" 
                        variant="primary" 
                        size="lg"
                        onClick={ () => setShowForm(true) }
                    >
                        <FontAwesomeIcon icon="plus" style={{ fontSize: 20 }} />
                        <span className="ps-2">Add Manager</span>
                    </Button>
                </Col>
                <Row className="justify-content-center">
                    <Col md={11}>
                        <Card className="border-0 shadow-sm rounded-16">
                            <Card.Body className="py-4 pe-3 ps-3 table-responsive-lg">
                            <Table size="sm" className="table-color">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Email Address</th>
                                        <th>Phone Number</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        members?.length ? (
                                            members.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <p className="m-0 d-flex gap-2 align-items-center">
                                                            <img src={item.photo || 'https://placehold.co/70'} alt={item.name} width="35" className="rounded-circle"/>
                                                            <strong>
                                                                {item.name}
                                                            </strong>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        {item.email}
                                                    </td>
                                                    <td>
                                                        {item.mobile_number}
                                                    </td>
                                                    <td>
                                                        <p className="d-flex m-0 align-items-center justify-content-between">
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-white" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    {
                                                                        item.active ? (
                                                                            <Dropdown.Item 
                                                                                eventKey={1} 
                                                                                className="d-flex align-items-center gap-1 text-danger" 
                                                                                onClick={ () => manageStatus(item) }
                                                                            >
                                                                                <FontAwesomeIcon icon="ban" style={{fontSize: "20px"}}/> Deactivate
                                                                            </Dropdown.Item>
                                                                        )
                                                                        :
                                                                        (
                                                                            <Dropdown.Item 
                                                                                eventKey={1} 
                                                                                className="d-flex align-items-center gap-1 text-success" 
                                                                                onClick={ () => manageStatus(item) }
                                                                            >
                                                                                <FontAwesomeIcon icon="circle-check" style={{fontSize: "20px"}}/> Activate
                                                                            </Dropdown.Item>
                                                                        )
                                                                    }
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="d-flex align-items-center gap-1 text-danger"
                                                                        onClick={ () => promptDelete(item) }
                                                                    >
                                                                        <FontAwesomeIcon icon="trash" /> Delete
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </p>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                        :
                                        (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted">No data found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <DrewsModal
                    show={showForm}
                    onHide={() => setShowForm(false)}
                    size="md"
                    dismissable={true}
                    title="New Manager"
                >
                    <Form noValidate>
                        <Row>
                            <FormGroup as={Col} md={12}>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="first_name"
                                    placeholder="First Name"
                                    onKeyUp={handleInput}
                                    required
                                />
                                {
                                    errors['first_name'] && 
                                    <Form.Text className="text-danger">{errors['first_name']}</Form.Text>
                                }
                            </FormGroup>
                            <FormGroup as={Col} md={12} className="mt-3">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control 
                                    type="text"
                                    name="last_name"
                                    placeholder="Last Name"
                                    required
                                    onKeyUp={handleInput}
                                />
                                {
                                    errors['last_name'] && 
                                    <Form.Text className="text-danger">{errors['last_name']}</Form.Text>
                                }
                            </FormGroup>
                            <FormGroup as={Col} md={12} className="mt-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control 
                                    type="email"
                                    name="email"
                                    pattern=".+@gmail\.com"
                                    placeholder="Email Address"
                                    required
                                    onKeyUp={handleInput}
                                />
                                {
                                    errors['email'] && 
                                    <Form.Text className="text-danger">{errors['email']}</Form.Text>
                                }
                            </FormGroup>
                            <FormGroup as={Col} md={12} className="mt-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control 
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number"
                                    required
                                    onKeyUp={handleInput}
                                    maxLength={11}
                                    minLength={11}
                                />
                                {
                                    errors['phone'] && 
                                    <Form.Text className="text-danger">{errors['phone']}</Form.Text>
                                }
                            </FormGroup>
                            <FormGroup as={Col} md={12} className="mt-3">
                                <Button 
                                    type="button" 
                                    variant="primary"
                                    className="form-control"
                                    onClick={createUser}
                                    disabled={Object.keys(errors).length > 0}
                                >
                                    Add Manager <Spinner animation={ loading ? "border" : null} variant="light" role="status" size="sm"></Spinner>
                                </Button>
                            </FormGroup>
                        </Row>
                    </Form>
                </DrewsModal>
            </Container>
        </Layout>
    );
}

export default Managers;